import { useMemo } from "react"
import { size } from "lodash"
import useResource from "hooks/resources"
import { generateClassificationQuery } from "helpers/classification"

export const CLASSIFICATIONS_QUERY = `query {
  classifications {
    name
    id
    proprietary
    versions{
      id
      asOf
      tiers{
        id
        level
        name
      }
    }
  }
}`

export function useClassifications() {
  return useResource({
    resource: "classifications",
    url: () => ({
      id: "classifications",
      query: CLASSIFICATIONS_QUERY,
    }),
  }, "classifications")
}

export function useClassificationsValues(classifications, startDate) {
  const classificationsTiers = useMemo(() => {
    if (!classifications) return []
    return classifications.reduce((acc, classification) => {
      const version = classification.versions.at(-1)
      return [
        ...acc,
        {
          tiers: version.tiers,
          id: classification.id,
          versionId: version.id,
          levels: version.tiers.length,
        },
      ]
    }, [])
  }, [classifications])

  return useResource({
    resource: "classificationsValues",
    url: () => {
      if (size(classificationsTiers) === 0 || !startDate) {
        return null
      }

      return {
        id: `classificationsValues-${startDate}-${JSON.stringify(classificationsTiers)}`,
        query: `query {
          ${generateClassificationQuery(classificationsTiers)}
        }`,
      }
    },
  }, [])
}
